export const STATUS_TABS = [
  { key: "all", label: "All" },
  { key: "in-transit", label: "In Transit" },
  { key: "out-for-delivery", label: "Out for Delivery" },
  { key: "ndr", label: "NDR" },
  { key: "delivered", label: "Delivered" },
];

export const StatusTabs = ({ value, onChange, counts = {}, prefix = "status" }) => (
  <div className="flex gap-0 border-2 border-obsidian w-fit bg-white flex-wrap" data-testid={`${prefix}-status-tabs`}>
    {STATUS_TABS.map((t) => (
      <button
        key={t.key}
        onClick={() => onChange(t.key)}
        data-testid={`${prefix}-status-tab-${t.key}`}
        className={`px-4 py-2 text-[11px] font-mono font-bold uppercase tracking-widest transition-colors duration-150 ${
          value === t.key ? "bg-obsidian text-sky-300" : "hover:bg-acid/40"
        }`}
      >
        {t.label}
        {counts[t.key] != null ? ` (${counts[t.key]})` : ""}
      </button>
    ))}
  </div>
);
